import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function MessagesListPage() {
  return (
    <SectionLayout title="Messages">
      {/* Messages content will go here */}
    </SectionLayout>
  );
} 